<template>
  <div class="bc-bubble">
    <img v-if="imageUrl"
         class="bc-img"
         :src="imageUrl"
         alt="" />
    <div class="bc-text"><template v-if="parts.length"><span v-for="(part, i) in parts"
              :key="i"
              :class="part.kind ? 'ph --' + part.kind : null">{{ part.t }}</span></template><span v-else-if="empty"
            class="bc-faint">{{ empty }}</span></div>
  </div>
</template>

<script>
// A Messenger-style bubble: optional picture on top, text below. `parts` is [{t, kind}] where kind
// "" | name | slot | faint colours a placeholder or a filled value (see copy.js splitMarks).
export default {
  name: "BcBubble",
  props: {
    parts: { type: Array, default: () => [] },
    imageUrl: { type: String, default: "" },
    empty: { type: String, default: "" }, // shown faint when there is no text
  },
};
</script>

<style lang="scss" scoped>
.bc-bubble {
  display: block;
  background: #f0f0f0;
  border-radius: 18px;
  max-width: 100%;
  overflow: hidden;
  color: #1c1e21;
  text-align: left;
}

.bc-text {
  display: block;
  padding: 0.6rem 0.9rem;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 0.9375rem;
  line-height: 1.45;
}

.bc-img {
  display: block;
  width: 100%;
  max-height: 260px;
  object-fit: cover;
}

.bc-faint {
  color: #6b6b6b;
}

.ph {
  border-radius: 3px;
  white-space: nowrap;

  &.--name {
    color: #5f6368;
    background: #e8e8e8;
  }

  &.--slot {
    color: #1c75bb;
    background: #f0f8ff;
    font-weight: 700;
  }

  &.--faint {
    color: #6b6b6b;
  }
}

body.--dark {
  .bc-bubble {
    background: #4b4b4b;
    color: #e6e6e6;
  }

  .bc-faint,
  .ph.--faint {
    color: #c4c4c4;
  }

  .ph.--name {
    color: #e0e0e0;
    background: #555;
  }

  .ph.--slot {
    color: #9fd2f8;
    background: #12334d;
  }
}
</style>

